import { NavigationService } from '@/navigations/navigation-ref';
import type { PublicScreenParamList } from '@/navigations/types';
import type { ComponentType } from 'react';
import React from 'react';
import { Button, StyleSheet, Text, View } from 'react-native';

type PublicScreenName = keyof PublicScreenParamList;

type PublicScreenConfig = {
  name: PublicScreenName;
  component: ComponentType<any>;
};

// TODO: replace with actual screen components
function PlaceholderScreen({ title }: { title: string }) {
  return (
    <View style={styles.root}>
      <Text>{title}</Text>
      <Button title="Go back" onPress={() => NavigationService.goBack()} />
    </View>
  );
}

export function createPlaceholder(title: string) {
  return function Placeholder() {
    return <PlaceholderScreen title={title} />;
  };
}

export const publicScreens: PublicScreenConfig[] = [
  { name: 'Test', component: createPlaceholder('Test (Public)') },
];

const styles = StyleSheet.create({
  root: { flex: 1, justifyContent: 'center', alignItems: 'center' },
});
